import {
	fetchActivities,
	fetchUsers,
	generatePassword as generateUserPassword,
	addPublicationExternalResearcher as addExternalResearcherToPublication,
} from './api'

const getResearchers = async({ commit, state }, payload) => {
	const pageSize  = payload.pageSize ? payload.pageSize : 50
	const page      = payload.page ? payload.page : 1
	const { query } = payload
	
	let users = []
	
	try {
		users = (await fetchUsers({
			query,
			pageSize,
			page,
		})).data.data
		
		if(page > 1) {
			users = state.researchers.concat(users)
		}
		
		commit('SET_RESEARCHERS', users)
		
		return users
	} catch(e) {
		console.error(e)
	}
}

const getActivities = async ({ commit, state }, payload) => {
	const { page, ...rest } = payload || {}
	
	let activities = []
	
	try {
		activities = (await fetchActivities({
			page,
			...rest,
		})).data.activities
		
		if (page > 1) {
			activities = state.activities.concat(activities)
		}
		
		commit('SET_ACTIVITIES', activities)
		
		return activities
	}
	catch (e) {
		console.error(e)
	}
}

const generatePassword = async ({ commit }, payload) => {
	try {
		return await generateUserPassword(payload)
	}
	catch (e) {
		console.error(e)
	}
}

const addPublicationExternalResearcher = async({ commit }, payload) => {
	try {
		const response = await addExternalResearcherToPublication(payload)
		
		return response.data.data
	} catch (e) {
		console.error(e)
	}
}

export default {
	getResearchers,
	getActivities,
	generatePassword,
	addPublicationExternalResearcher,
}
